import { lazy } from 'react';

const Col = lazy(() => import('./Col'));

export { Col };
